var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("You should have an "),_c('code',[_vm._v("inline-template")]),_vm._v(" directive on the component")])
}]

export { render, staticRenderFns }